import MapsService, {IconType, LocationType} from "@churchofjesuschrist/maps-service";

export default function mapBoundariesDirective(MapService) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/map-boundaries/map-boundaries-template.html",
		scope: {
			options: "=",
			onChange: "&"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function () {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				const defaultOptions = {
					automatic: true,
					types: []
				};
				angular.extend(vm.options, defaultOptions, vm.options);

				vm.boundaries = [
					{
						label: "pros-maps.map.options.automatic"
					},
					{
						label: "pros-maps.org.pros.areas",
						type: "AREA",
					},
					{
						label: "pros-maps.org.pros.districts",
						type: "DISTRICT",
					},
					{
						label: "pros-maps.org.pros.zones",
						type: "ZONE",
					},
					{
						label: "pros-maps.layer.wards",
						type: "WARD",
					},
					{
						label: "pros-maps.layer.ward_overlays",
						type: "WARD_OVERLAY",
					},
					{
						label: "pros-maps.layer.stakes",
						type: "STAKE",
					},
					{
						label: "pros-maps.layer.stake_overlays",
						type: "STAKE_OVERLAY",
					},
					{
						label: "pros-maps.org.customs",
						type: "CUSTOM",
					},
					{
						label: "pros-maps.org.historic_places",
						type: "HISTORIC_SITE",
					},
					{
						label: "pros-maps.org.visitors_center",
						type: "VISITORS_CENTER",
					},
					{
						label: "pros-maps.org.meeting_houses",
						type: "MEETINGHOUSE",
					},
					{
						label: "pros-maps.org.temples",
						type: "TEMPLE",
					}
				];

				vm.boundaries.forEach((boundary) => {
					boundary.selected = boundary.type ? vm.options.types.indexOf(boundary.type) !== -1 : vm.options.automatic;
					boundary.color = MapService.getColor(boundary.type);
					boundary.iconUrl = MapService.getIconUrl(boundary.type);
				});
			};


			vm.updateOptions = (boundary) => {
				if (!boundary.type) {
					vm.options.automatic = boundary.selected;
				} else {
					let index = vm.options.types.indexOf(boundary.type);
					if (boundary.selected) {
						if (index === -1) {
							vm.options.types.push(boundary.type);
						}
					} else {
						vm.options.types.splice(index, 1);
					}
				}

				if (vm.onChange) {
					vm.onChange();
				}
			};

			vm.getModeLabel = () => {
				let label = null;
				if (vm.options.automatic) {
					label = vm.boundaries[0].label;
				} else if (!vm.options.types.length) {
					label = "pros-maps.map.options.hidden";
				} else if (vm.options.types.length === 1) {
					let type = vm.options.types[0];
					label = vm.boundaries.filter((boundary) => (boundary.type === type))[0].label;
				} else if (vm.options.types.length > 1) {
					label = "pros-maps.map.options.custom";
				}
				return label;
			};
		}
	};
}
